export const scaleUnits = [{
  name: 'millimeter',
  abbreviation: 'mm',
  scaleFactor: 0.001
}, {
  name: 'centimeter',
  abbreviation: 'cm',
  scaleFactor: 0.01
}, {
  name: 'meter',
  abbreviation: 'm',
  scaleFactor: 1
}, {
  name: 'inch',
  abbreviation: 'in',
  scaleFactor: 0.0254
}, {
  name: 'foot',
  abbreviation: 'ft',
  scaleFactor: 0.3048
}, {
  name: 'yard',
  abbreviation: 'yd',
  scaleFactor: 0.9144
}];